import { getCustomerPortalRedirect } from "../../api";

export const handleCustomerPortalRedirect = async (setLoading, url) =>
{
  if (typeof setLoading == 'function')
  {
    setLoading(true);
  }
  document.location = url;
  return true;
};

export const getCustomerPortalUrl = async () =>
{
  try {
    let response = await getCustomerPortalRedirect(document.location.href);
    if (response.code === 200) {
      return (response.data)? response.data.url : null;
    }
  }
  catch (e) {
    console.log(`error getting customer portal url ${e.message}`);
  }
  
  return null;
};

export const checkForFailedInvoices = async (baseContext, setError) =>
{
  if (!baseContext.invoiceData?.loading && baseContext.invoiceData.failedInvoices)
  {
    setError({
      show: true,
      showBtn: true,
      btnText: 'Update Now',
      onClick: handleCustomerPortalRedirect,
      message: 'There is an issue with your payment method. Please update'
    });
  }
}